import {defineComponent} from "vue";
import {NewsCardInterface} from "../Components/Interfaces/NewsCardInterface";

export default defineComponent({
		methods: {
			openNewsDetail(news: NewsCardInterface) {
				this.$router.push({path: this.newsLocalizeLink(news.slug)});
			}
		},
	}
);
